import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillUserSelectorV1FieldComponent } from './fill-user-selector-v1/fill-user-selector-v1.component';
import { ViewUserSelectorV1FieldComponent } from './view-user-selector-v1/view-user-selector-v1.component';
import { SettingsUserSelectorV1FieldComponent } from './settings-user-selector-v1/settings-user-selector-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillUserSelectorV1FieldComponent,
        ViewUserSelectorV1FieldComponent,
        SettingsUserSelectorV1FieldComponent
    ],
    exports: [
        FillUserSelectorV1FieldComponent,
        ViewUserSelectorV1FieldComponent,
        SettingsUserSelectorV1FieldComponent
    ],

})
export class CoreCustomFormsFieldUserSelectorV1FieldsModule { }
